import { hsaReimbursementFieldSpec } from "@redotech/redo-conversion-hsa-common/reimbursement/hsa-reimbursement-fields";
import * as z from "zod";

/**
 * The supported-provider directory. Each entry carries the field specs for the
 * account types Redo can file for; a `null` side means that account type is
 * not offered. "Other" is not in the list — the portal appends it.
 */
export const getHsaReimbursementProviders = {
  name: "getHsaReimbursementProviders" as const,
  input: z.object({}),
  output: z.object({
    providers: z.array(
      z.object({
        name: z.string(),
        hsa: z.array(hsaReimbursementFieldSpec).nullable(),
        fsa: z.array(hsaReimbursementFieldSpec).nullable(),
      }),
    ),
  }),
};
